export const VAT_URL = process.env.REACT_APP_VAT_URL || "";
